import { fetchPageAssets } from '../../ducks/hostedAssets.duck';

// Dummy reducer to satisfy combineReducers
const initialState = {};
function reducer(state = initialState, _action = {}) {
  return state;
}

export default reducer;

export const ASSET_NAME = 'terms-of-service';

export const loadData = (_params, _search) => dispatch => {
  const pageAsset = { termsOfService: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
